import { formatListDate } from "@/utils/date-format";

export function formatInr(amount: number | undefined | null): string {
  if (amount == null || Number.isNaN(amount)) return "—";
  return `₹${amount.toLocaleString("en-IN")}`;
}

export function formatShortDate(iso: string | null | undefined): string {
  return formatListDate(iso, { empty: "—" });
}
